







import { Ref, Prop, Vue, Component, Watch } from "vue-property-decorator";
import TokenField from "./tokenfield.vue";
import { TokenFieldValue, BulkTemplateField } from '../model/frontend/BulkIssueTemplate';
 
class BulkFieldSlotData {
    public constructor(private bulkField: BulkField)
    {

    }

    public get value()
    {
        return this.bulkField.value.value;
    }

    public set value(newValue)
    {
        this.bulkField.value.value = newValue;
        this.bulkField.$emit('input', this.bulkField.value);
    }

    public get disabled()
    {
        return !this.bulkField.isNew && !this.bulkField.value.isChanged;
    }
}

@Component({
	components: {
    },
})
export default class BulkField extends Vue {
	@Prop({ required: true }) public isNew!: boolean;
    @Prop({ required: true }) public value!: BulkTemplateField<any>;

    public slotProps: BulkFieldSlotData | null = null;

    created()
    {
        // This has to be set in mounted(), not in the constructor,
        // otherwise Vue Devtools gets confused by the circular reference.
        this.slotProps = new BulkFieldSlotData(this);
    }
}
